import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { FormattedMessage } from "react-intl";
import { Col } from "components/Containers";
import { InlineProgressBar } from "components/Progress";
import { AIRoleBuilderTaskStage } from "components/Missions/Roles/AIRoleBuilder";
import { colors, fontSize, margins } from "style";

/**
 * TaskProcessing
 *
 * What the job description step shows while the AI builds the role: what it is doing now,
 * and that the customer is free to leave and come back.
 *
 * @param {Object}  task  The AI role builder request being waited on
 */
const TaskProcessing = ({ task }) => (
  <Col gap={margins.xsmall} css={styles.container}>
    <Col gap={margins.xxsmall} css={styles.message}>
      <span>
        <FormattedMessage id="Missions.Roles.TalentSimple.RoleBuilder.Processing.Title" />
      </span>
      <span css={styles.hint}>
        <FormattedMessage id="Missions.Roles.TalentSimple.RoleBuilder.Processing.Description" />
      </span>
    </Col>
    <InlineProgressBar
      css={styles.progress}
      label={<AIRoleBuilderTaskStage task={task} />}
      completed={task?.stepsCompleted || 0}
      total={task?.stepsTotal || 0}
    />
  </Col>
);

const CONTENT_WIDTH = "50rem";

const styles = {
  container: css`
    align-items: center;
    justify-content: center;
    min-height: 32rem;
  `,
  message: css`
    align-items: center;
    text-align: center;
    width: 100%;
    max-width: ${CONTENT_WIDTH};
    padding: ${margins.normal};
    border: 1px solid ${colors.grayAnatomyLight4};
    border-radius: 0.8rem;
    color: ${colors.purpleRainDark2};
    font-size: ${fontSize.small};
    line-height: 1.5;
  `,
  hint: css`
    color: ${colors.grayAnatomyLight1};
  `,
  progress: css`
    width: 100%;
    max-width: ${CONTENT_WIDTH};
  `,
};

TaskProcessing.propTypes = {
  task: PropTypes.object,
};

export default TaskProcessing;
